import React from 'react';

export type PillVariant = 'default' | 'gold' | 'sage' | 'forest';
export type PillSize = 'sm' | 'md';

export interface PillProps {
  variant?: PillVariant;
  size?: PillSize;
  children: React.ReactNode;
  className?: string;
}

const VARIANT: Record<PillVariant, string> = {
  default: 'bg-pt-cream text-pt-forest border border-subtle',
  gold: 'bg-pt-bird-cream text-pt-gold-text border border-subtle',
  sage: 'bg-pt-sage text-pt-forest',
  forest: 'bg-pt-forest text-pt-cream',
};

const SIZE: Record<PillSize, string> = {
  sm: 'text-xs px-2.5 py-1',
  md: 'text-sm px-3 py-1.5',
};

const Pill: React.FC<PillProps> = ({
  variant = 'default',
  size = 'md',
  children,
  className = '',
}) => (
  <span
    className={`inline-flex items-center font-medium rounded-full ${VARIANT[variant]} ${SIZE[size]} ${className}`.trim()}
  >
    {children}
  </span>
);

export default Pill;
